import { _ as _assign, b as __awaiter, c as __generator, a as __rest } from './tslib.es6-c6da0ae6.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useRef, useCallback, useEffect, useState, memo, useMemo, lazy, Suspense } from 'react';
import AnalyticsService from '@picsart/rc/services/analytics';
import { IconCrossCircleFilled } from '@picsart/design-system/foundation/icons/IconCrossCircleFilled';
import { Overlay, VerticalAlign, HorizontalAlign } from '@picsart/design-system/components/Overlay';
import { S as StatusOptions, e as ComponentsOptions, j as AnalyticsSkipScreenOptions, A as ANALYTICS_SCREEN_NAME_KEY, k as APPLE_PLATFORM_SCRIPT_URL, R as RestrictedGeoZones, P as ProviderOptions, l as RECENT_LOGIN_BTN_PULSE_NAME, a as ANALYTICS_CONSENTS_KEY } from './constants-e3c79897.js';
import { setStorage, getStorage, removeStorage } from './services/browserStorage/index.js';
import { a as useAuthModalData, u as useRegistrationFormContext, b as useRemoteSettingsContext, R as RegistrationFormProvider, c as RemoteSettingsProvider } from './RegistrationFormContext-20b6a976.js';
import { A as AuthModalDataForms, d as defaultState } from './constants-8010f63c.js';
import { u as useAuthContext, a as authStatus } from './authContext-a01efdfb.js';
import '@picsart/rc/services/http';
import '@picsart/rc/useMount';
import 'react-dom';
import './models/user/index.js';
import { k as useFacebookAuth } from './requestFactory-4dc9ec32.js';
import './isBrowser/index.js';
import { EMAIL, GOOGLE, APPLE, FACEBOOK, RECAPTCHA_SCRIPT_SRC, REGISTRATION_DONE, ANALYTICS_PLATFORM_TYPE } from './configs/constants/index.js';
import errorLogger, { BUGSNAG_STATUSES } from './services/errorLogger/index.js';
import './services/logger/index.js';
import './services/auth/index.js';
import './styles-59499c92.js';
import { u as useStyles, a as useStyles$1, b as useStyles$2, c as useStyles$3, d as useGoogleButtonStyles, A as AuthButtonsData, i as isMobile_1, e as isSafari_1, f as useStyles$4, g as useStyles$5, h as useStyles$6, j as useStyles$7, k as useStyles$8, l as useStyles$9, m as imageData } from './data-dab7692c.js';
import { loadScript } from './services/asyncLoaderService/index.js';
import classNames from 'classnames';
import useGeoZone from './useGeozone/index.js';
import { a as useGoogleAuth, u as useAuth } from './useGoogleAuth-d54a1d14.js';
import useRegistrationAnalytics from './useRegistrationAnalytics/index.js';
import useIsIncognito from './useIsIncognito/index.js';
import { TypographyT8, TypographyT7, TypographyT5, TypographyT3 } from '@picsart/design-system/foundation/typography';
import { Text, TextElementTypes } from '@picsart/design-system/components/Text';
import { useTranslator } from '@picsart/rc/services/localization';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { ScreenSizes } from '@picsart/design-system/foundation/responsive';
import { Button, ButtonSkinPrimary, ButtonSizeLG, ButtonVariants, ButtonElementTypes, ButtonSizeXL, ButtonSkinTertiary } from '@picsart/design-system/components/Button';
import { IconChevronLeftLarge } from '@picsart/design-system/foundation/icons/IconChevronLeftLarge';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect/index.js';
import { TextColors } from '@picsart/design-system/foundation/colors';
import { S as SanitizeHtml } from './SanitizeHtml-299f5620.js';
import 'isomorphic-dompurify';
import { IconApple } from '@picsart/design-system/foundation/icons/IconApple';
import { IconEmail } from '@picsart/design-system/foundation/icons/IconEmail';
import { IconFacebookColored } from '@picsart/design-system/foundation/icons/IconFacebookColored';
import { IconGoogleColored } from '@picsart/design-system/foundation/icons/IconGoogleColored';
import useDelayedScript from './useDelayedScript/index.js';
import { getRecentLoginMethods } from './services/recentLoginMethods/index.js';
import { useTheme } from 'react-jss';

function Footer(_a) {
  var clickHandler = _a.clickHandler,
    label = _a.label,
    buttonDisabled = _a.buttonDisabled,
    backHandler = _a.backHandler,
    status = _a.status,
    _b = _a.buttonType,
    buttonType = _b === void 0 ? 'button' : _b;
  var root = useStyles().root;
  var translate = useTranslator();
  var submitButton = useRef(null);
  useIsomorphicLayoutEffect(function () {
    document.addEventListener('keydown', function (e) {
      if (submitButton.current !== null && e.key === 'Enter') {
        e.preventDefault();
        submitButton.current.click();
      }
    });
  }, []);
  return jsxs("div", _assign({
    className: root,
    "data-testid": "registration-popup-footer",
    "data-pulse-section-group": "continue with email"
  }, {
    children: [jsx(Button, {
      "data-pulse-name": "reg-back-button",
      "data-testid": "reg-back-button",
      onClick: backHandler,
      centerIcon: IconChevronLeftLarge,
      skin: ButtonSkinPrimary,
      size: ButtonSizeLG,
      variant: ButtonVariants.Outline
    }), jsx(Button, _assign({
      "data-pulse-name": label,
      "data-testid": "reg-continue-button",
      tag: ButtonElementTypes.Button,
      isSubmitButton: buttonType === 'submit',
      onClick: clickHandler,
      isDisabled: buttonDisabled,
      ref: submitButton,
      size: ButtonSizeLG,
      isLoading: status === StatusOptions.Submitting
    }, {
      children: translate(label)
    }))]
  }));
}

function NoInternet() {
  var _a;
  var _b = useStyles$1(),
    formContent = _b.formContent,
    root = _b.root;
  var _c = useAuthModalData(AuthModalDataForms.noInternetForm),
    title = _c.title,
    description = _c.description;
  var _d = useRegistrationFormContext(),
    setCurrentPage = _d.setCurrentPage,
    setStatus = _d.setStatus;
  var translate = useTranslator();
  var handleClick = useCallback(function (e) {
    e.preventDefault();
    setStatus({
      type: StatusOptions.Default,
      message: ''
    });
    setCurrentPage(ComponentsOptions.EmailForm);
  }, [setCurrentPage, setStatus]);
  useEffect(function () {
    setStorage(ANALYTICS_SCREEN_NAME_KEY, AnalyticsSkipScreenOptions.Connection, false);
  }, []);
  return jsxs("div", _assign({
    className: root,
    "data-testid": "no-internet"
  }, {
    children: [jsxs("div", _assign({
      className: formContent
    }, {
      children: [jsx(Text, _assign({
        size: (_a = {
          Default: TypographyT8
        }, _a[ScreenSizes.XL] = TypographyT8, _a[ScreenSizes.MD] = TypographyT7, _a),
        weight: FontWeights.semibold,
        elementType: TextElementTypes.H3
      }, {
        children: translate(title)
      })), jsx(Text, _assign({
        size: TypographyT5
      }, {
        children: translate(description)
      }))]
    })), jsx(Footer, {
      backHandler: function backHandler(e) {
        return handleClick(e);
      },
      clickHandler: function clickHandler(e) {
        return handleClick(e);
      },
      label: "Retry"
    })]
  }));
}

var onTermsAnalytics = function onTermsAnalytics(item) {
  AnalyticsService.sendEvent('button_click', {
    screen_name: 'registration_popup',
    item: item
  });
};
var basePath = 'https://picsart.com/';
function PicsartLegal() {
  var styles = useStyles$2();
  var translate = useTranslator();
  var clickHandler = useCallback(function (e) {
    var _a;
    if ((_a = e.target.href) === null || _a === void 0 ? void 0 : _a.includes('/terms')) {
      onTermsAnalytics('terms_of_use');
    } else {
      onTermsAnalytics('privacy_policy');
    }
  }, []);
  return jsx(Text, _assign({
    className: styles.root,
    elementType: TextElementTypes.Span,
    weight: FontWeights.medium,
    size: TypographyT3,
    color: TextColors.tint1
  }, {
    children: jsx(SanitizeHtml, {
      onClick: function onClick(e) {
        return clickHandler(e);
      },
      html: translate('reusable_components_terms_of_use', {
        basePath: basePath,
        className: styles.link,
        dataPulseName: 'Read our privacy policy',
        tabIndex: 0,
        ariaLabelPrivacyPolice: 'Read our privacy policy'
      }),
      tag: "p"
    })
  }));
}

var AppleButton = function AppleButton(_a) {
  var redirectURI = _a.redirectURI,
    clientId = _a.clientId,
    scope = _a.scope,
    nonce = _a.nonce,
    usePopup = _a.usePopup,
    callback = _a.callback,
    children = _a.children;
  var isScriptLoaded = useDelayedScript(APPLE_PLATFORM_SCRIPT_URL);
  var style = useStyles$3();
  var login = function login() {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, window.AppleID.auth.signIn()];
          case 1:
            data = _a.sent();
            callback(data);
            return [3, 3];
          case 2:
            error_1 = _a.sent();
            callback(error_1);
            return [3, 3];
          case 3:
            return [2];
        }
      });
    });
  };
  useEffect(function () {
    if (!isScriptLoaded) {
      return;
    }
    window.AppleID.auth.init({
      redirectURI: redirectURI,
      clientId: clientId,
      scope: scope,
      nonce: nonce,
      usePopup: usePopup
    });
  }, [isScriptLoaded, redirectURI, clientId, scope, nonce, usePopup]);
  return jsx("button", _assign({
    className: style.button,
    onClick: login
  }, {
    children: children
  }));
};

function GoogleButtonWrapper(_a) {
  var children = _a.children,
    buttonWidth = _a.buttonWidth,
    handleGoogleResponse = _a.handleGoogleResponse,
    _b = _a.hideOneTap,
    hideOneTap = _b === void 0 ? false : _b,
    prefilledEmail = _a.prefilledEmail;
  var classesSocial = useGoogleButtonStyles();
  var _c = useState(null),
    googleButton = _c[0],
    setGoogleButton = _c[1];
  useGoogleAuth(handleGoogleResponse, googleButton, buttonWidth, null, hideOneTap, false, prefilledEmail);
  return jsxs("div", _assign({
    id: "button-wrapper",
    className: classesSocial.googleSignInWrapper
  }, {
    children: [jsx("div", {
      "data-pulse-clickable": true,
      "data-pulse-name": AuthButtonsData.ContinueWithGoogle,
      className: classesSocial.googleNativeButton,
      ref: function ref(_ref) {
        return setGoogleButton(_ref);
      }
    }), jsx("span", _assign({
      className: classesSocial.googleSignInVisual
    }, {
      children: children
    }))]
  }));
}

var useShowFacebookButton = function useShowFacebookButton() {
  var _a = useRegistrationFormContext(),
    isIncognito = _a.isIncognito,
    geoZone = _a.geoZone;
  if (geoZone === RestrictedGeoZones.Russia) return false;
  if (isMobile_1 && (isIncognito || isSafari_1)) return false;
  return true;
};

function AuthButtons(_a) {
  var _b;
  var handleAppleClick = _a.handleAppleClick,
    appleRedirectUrl = _a.appleRedirectUrl,
    handleGoogleClick = _a.handleGoogleClick,
    handleFacebookClick = _a.handleFacebookClick,
    handleEmailClick = _a.handleEmailClick,
    hideOneTap = _a.hideOneTap,
    hideSocialActions = _a.hideSocialActions,
    btnDataPulseName = _a.btnDataPulseName,
    emailBtnText = _a.emailBtnText,
    _c = _a.buttonsOptions,
    buttonsOptions = _c === void 0 ? [] : _c,
    _d = _a.fromWelcomeBack,
    fromWelcomeBack = _d === void 0 ? false : _d;
  var styles = useStyles$4();
  var translate = useTranslator();
  var showFacebookButton = useShowFacebookButton();
  useFacebookAuth(true);
  var buttons = [];
  var icons = (_b = {}, _b[EMAIL] = IconEmail, _b[GOOGLE] = IconGoogleColored, _b[APPLE] = IconApple, _b[FACEBOOK] = IconFacebookColored, _b);
  buttonsOptions.forEach(function (_a) {
    var name = _a.name,
      text = _a.text,
      primary = _a.primary,
      _b = _a.show,
      show = _b === void 0 ? true : _b,
      _c = _a.showIcon,
      showIcon = _c === void 0 ? true : _c,
      prefilledData = _a.prefilledData;
    if (!show) return;
    var buttonSkin = primary ? ButtonSkinPrimary : ButtonSkinTertiary;
    var icon = showIcon ? icons[name] : null;
    if (name === EMAIL) {
      buttons.push(jsx(Button, _assign({
        isFullWidth: true,
        size: ButtonSizeXL,
        skin: buttonSkin,
        startIcon: icon,
        className: classNames(styles.socialButton),
        "data-pulse-name": btnDataPulseName !== null && btnDataPulseName !== void 0 ? btnDataPulseName : AuthButtonsData.ContinueWithEmail,
        "aria-label": AuthButtonsData.ContinueWithEmail,
        onClick: function onClick(e) {
          return handleEmailClick(e, prefilledData === null || prefilledData === void 0 ? void 0 : prefilledData.email, prefilledData === null || prefilledData === void 0 ? void 0 : prefilledData.username);
        }
      }, {
        children: text !== null && text !== void 0 ? text : translate(emailBtnText !== null && emailBtnText !== void 0 ? emailBtnText : AuthButtonsData.ContinueWithEmail)
      }), name));
    }
    if (!hideSocialActions) {
      if (name === GOOGLE) {
        buttons.push(jsx(GoogleButtonWrapper, _assign({
          prefilledEmail: prefilledData === null || prefilledData === void 0 ? void 0 : prefilledData.email,
          handleGoogleResponse: function handleGoogleResponse(data) {
            return handleGoogleClick(data, fromWelcomeBack, null);
          },
          buttonWidth: 378,
          hideOneTap: hideOneTap
        }, {
          children: jsx(Button, _assign({
            "data-testid": "socialAuth-actionButton",
            className: classNames(styles.socialButton, 'google-new-button'),
            size: ButtonSizeXL,
            startIcon: icon,
            "aria-label": AuthButtonsData.ContinueWithGoogle,
            skin: buttonSkin,
            isFullWidth: true,
            "data-pulse-name": btnDataPulseName !== null && btnDataPulseName !== void 0 ? btnDataPulseName : AuthButtonsData.ContinueWithGoogle
          }, {
            children: text !== null && text !== void 0 ? text : translate(AuthButtonsData.ContinueWithGoogle)
          }))
        }), name));
      }
      if (name === APPLE) {
        buttons.push(jsx(AppleButton, _assign({
          redirectURI: appleRedirectUrl !== null && appleRedirectUrl !== void 0 ? appleRedirectUrl : window.location.origin,
          clientId: "com.picsart.studio.servicesid",
          scope: "email name",
          nonce: "nonce",
          usePopup: true,
          callback: function callback(data) {
            return handleAppleClick(data, fromWelcomeBack);
          }
        }, {
          children: jsx(Button, _assign({
            className: styles.socialButton,
            size: ButtonSizeXL,
            startIcon: icon,
            "aria-label": AuthButtonsData.ContinueWithApple,
            "data-pulse-name": btnDataPulseName !== null && btnDataPulseName !== void 0 ? btnDataPulseName : AuthButtonsData.ContinueWithApple,
            skin: buttonSkin,
            isFullWidth: true
          }, {
            children: text !== null && text !== void 0 ? text : translate(AuthButtonsData.ContinueWithApple)
          }))
        }), name));
      }
      if (name === FACEBOOK && showFacebookButton) {
        buttons.push(jsx(Button, _assign({
          className: styles.socialButton,
          onClick: function onClick() {
            return handleFacebookClick(fromWelcomeBack);
          },
          size: ButtonSizeXL,
          startIcon: icon,
          "aria-label": AuthButtonsData.ContinueWithFB,
          "data-pulse-name": btnDataPulseName !== null && btnDataPulseName !== void 0 ? btnDataPulseName : AuthButtonsData.ContinueWithFB,
          skin: buttonSkin,
          isFullWidth: true
        }, {
          children: text !== null && text !== void 0 ? text : translate(AuthButtonsData.ContinueWithFB)
        }), name));
      }
      if (name === 'divider') {
        buttons.push(jsx("div", _assign({
          className: styles.divider
        }, {
          children: jsx(Text, _assign({
            elementType: TextElementTypes.Span,
            weight: FontWeights.semibold,
            size: TypographyT3,
            color: TextColors.tint2
          }, {
            children: translate('or')
          }))
        }), name));
      }
    }
  });
  return jsx("div", _assign({
    className: styles.root,
    "data-testid": "socialAuth-root",
    "data-pulse-section-group": "Social Auth"
  }, {
    children: buttons
  }));
}
var AuthButtons$1 = /*#__PURE__*/memo(AuthButtons);

function OptionsForm(_a) {
  var _b;
  var title = _a.title,
    description = _a.description,
    authOptions = _a.authOptions,
    handleAppleClick = _a.handleAppleClick,
    handleGoogleClick = _a.handleGoogleClick,
    handleFacebookClick = _a.handleFacebookClick,
    hideSocialActions = _a.hideSocialActions,
    appleRedirectUrl = _a.appleRedirectUrl,
    hideOneTap = _a.hideOneTap,
    buttonsOptions = _a.buttonsOptions;
  var styles = useStyles$5();
  var _c = useRegistrationFormContext(),
    setCurrentPage = _c.setCurrentPage,
    setEmail = _c.setEmail,
    setUsername = _c.setUsername;
  var translate = useTranslator();
  var handleEmailClick = useCallback(function (e) {
    e.preventDefault();
    setEmail('');
    setUsername('');
    setCurrentPage(ComponentsOptions.EmailForm);
    AnalyticsService.sendEvent('button_click', {
      screen_name: 'registration_popup',
      item: 'continue_email'
    });
  }, [setCurrentPage, setEmail, setUsername]);
  useEffect(function () {
    setStorage(ANALYTICS_SCREEN_NAME_KEY, AnalyticsSkipScreenOptions.General, false);
  }, []);
  return jsxs("div", _assign({
    className: styles.root
  }, {
    children: [title && jsx(Text, _assign({
      elementType: TextElementTypes.H3,
      weight: FontWeights.bold,
      size: (_b = {
        Default: TypographyT8
      }, _b[ScreenSizes.XL] = TypographyT8, _b[ScreenSizes.MD] = TypographyT7, _b),
      "data-test": "title",
      "data-testid": "Sign-in-options-title",
      "aria-label": "Sign in options title"
    }, {
      children: translate(title)
    })), description && jsx(Text, _assign({
      elementType: TextElementTypes.Paragraph,
      size: TypographyT5,
      "data-test": "description",
      "aria-label": "Sign in options description"
    }, {
      children: translate(description)
    })), jsx(AuthButtons$1, {
      handleFacebookClick: handleFacebookClick,
      handleGoogleClick: handleGoogleClick,
      handleAppleClick: handleAppleClick,
      handleEmailClick: handleEmailClick,
      appleRedirectUrl: appleRedirectUrl,
      hideOneTap: hideOneTap,
      hideSocialActions: hideSocialActions,
      emailBtnText: authOptions === null || authOptions === void 0 ? void 0 : authOptions.email,
      buttonsOptions: buttonsOptions
    }), jsx(PicsartLegal, {})]
  }));
}
var OptionsForm$1 = /*#__PURE__*/memo(OptionsForm);

function RecentloginMethods(_a) {
  var _b;
  var handleAppleClick = _a.handleAppleClick,
    handleGoogleClick = _a.handleGoogleClick,
    handleFacebookClick = _a.handleFacebookClick,
    hideSocialActions = _a.hideSocialActions,
    appleRedirectUrl = _a.appleRedirectUrl,
    hideOneTap = _a.hideOneTap;
  var recentLoginmethods = getRecentLoginMethods();
  var _c = useAuthModalData(AuthModalDataForms.recentLoginMethodsForm),
    title = _c.title,
    buttonTitle = _c.buttonTitle,
    authButtonPrefix = _c.authButtonPrefix;
  var styles = useStyles$6();
  var _d = useRegistrationFormContext(),
    setCurrentPage = _d.setCurrentPage,
    setEmail = _d.setEmail,
    setUsername = _d.setUsername;
  var translate = useTranslator();
  var handleEmailClick = useCallback(function (e, email, username) {
    e.preventDefault();
    if (email) {
      setEmail(email);
    }
    if (username) {
      setUsername(username);
    }
    setCurrentPage(ComponentsOptions.InsertPasswordForm);
  }, [setCurrentPage, setEmail, setUsername]);
  var continueWithAnotherAccount = useCallback(function () {
    setCurrentPage(ComponentsOptions.OptionsForm);
    setEmail('');
  }, [setCurrentPage, setEmail]);
  var buttonOptions = useMemo(function () {
    return recentLoginmethods.map(function (method) {
      return {
        name: method.provider,
        text: method.username && method.provider === ProviderOptions.email ? "".concat(translate(authButtonPrefix), " ").concat(method.username) : undefined,
        show: true,
        prefilledData: {
          username: method.username,
          email: method.email
        }
      };
    });
  }, [authButtonPrefix, recentLoginmethods, translate]);
  return jsxs("div", _assign({
    className: styles.root
  }, {
    children: [jsx(Text, _assign({
      elementType: TextElementTypes.H3,
      weight: FontWeights.bold,
      size: (_b = {
        Default: TypographyT8
      }, _b[ScreenSizes.XL] = TypographyT8, _b[ScreenSizes.MD] = TypographyT7, _b),
      "data-test": "title",
      "data-testid": "recent-login-methods-title",
      "aria-label": "Recent login methods title"
    }, {
      children: translate(title)
    })), jsxs("div", _assign({
      className: styles.options,
      "data-pulse-section-group": "Social Auth"
    }, {
      children: [jsx(AuthButtons$1, {
        handleAppleClick: handleAppleClick,
        appleRedirectUrl: appleRedirectUrl,
        handleGoogleClick: handleGoogleClick,
        handleFacebookClick: handleFacebookClick,
        handleEmailClick: handleEmailClick,
        hideSocialActions: hideSocialActions,
        btnDataPulseName: RECENT_LOGIN_BTN_PULSE_NAME,
        hideOneTap: hideOneTap,
        buttonsOptions: buttonOptions
      }), jsx(Button, _assign({
        onClick: continueWithAnotherAccount,
        size: ButtonSizeXL,
        "data-pulse-name": "continue with another account",
        skin: ButtonSkinTertiary,
        isFullWidth: true
      }, {
        children: buttonTitle
      }))]
    })), jsx(PicsartLegal, {})]
  }));
}
var RecentLoginMethods = /*#__PURE__*/memo(RecentloginMethods);

var componentImporters = {
  EmailForm: function EmailForm() {
    return import('./index-c084c044.js');
  },
  CreatePasswordForm: function CreatePasswordForm() {
    return import('./index-6f5787d0.js');
  },
  InsertPasswordForm: function InsertPasswordForm() {
    return import('./index-fef51b04.js');
  },
  AccountTermination: function AccountTermination() {
    return import('./index-dc538d6d.js');
  },
  ToGetStarted: function ToGetStarted() {
    return import('./index-a80d3604.js');
  },
  WelcomeBackEmailCodeAndSSO: function WelcomeBackEmailCodeAndSSO() {
    return import('./index-1b1bd4bd.js');
  },
  WelcomeBackMultipleSSO: function WelcomeBackMultipleSSO() {
    return import('./index-ffc86480.js');
  },
  UsernameForm: function UsernameForm() {
    return import('./index-d9c15fb6.js');
  },
  UsernameFormSSO: function UsernameFormSSO() {
    return import('./index-b2f494d0.js');
  }
};
var ComponentsMap = {
  OptionsForm: OptionsForm$1,
  RecentLoginMethods: RecentLoginMethods,
  NoInternet: NoInternet,
  EmailForm: /*#__PURE__*/lazy(componentImporters.EmailForm),
  CreatePasswordForm: /*#__PURE__*/lazy(componentImporters.CreatePasswordForm),
  InsertPasswordForm: /*#__PURE__*/lazy(componentImporters.InsertPasswordForm),
  AccountTermination: /*#__PURE__*/lazy(componentImporters.AccountTermination),
  ToGetStarted: /*#__PURE__*/lazy(componentImporters.ToGetStarted),
  WelcomeBackEmailCodeAndSSO: /*#__PURE__*/lazy(componentImporters.WelcomeBackEmailCodeAndSSO),
  WelcomeBackMultipleSSO: /*#__PURE__*/lazy(componentImporters.WelcomeBackMultipleSSO),
  UsernameForm: /*#__PURE__*/lazy(componentImporters.UsernameForm),
  UsernameFormSSO: /*#__PURE__*/lazy(componentImporters.UsernameFormSSO)
};
var useCurrentPageComponent = function useCurrentPageComponent(currentPage) {
  useEffect(function () {
    if (currentPage === ComponentsOptions.OptionsForm) {
      componentImporters.EmailForm();
      componentImporters.WelcomeBackEmailCodeAndSSO();
      componentImporters.WelcomeBackMultipleSSO();
      componentImporters.UsernameFormSSO();
    } else if (currentPage === ComponentsOptions.RecentLoginMethods) {
      componentImporters.InsertPasswordForm();
    } else if (currentPage === ComponentsOptions.EmailForm) {
      componentImporters.CreatePasswordForm();
      componentImporters.InsertPasswordForm();
      componentImporters.UsernameForm();
    }
  }, [currentPage]);
  return ComponentsMap[currentPage || ComponentsOptions.OptionsForm];
};

function AuthForm(_a) {
  var _b;
  var title = _a.title,
    description = _a.description,
    authSuccessHandler = _a.authSuccessHandler,
    onTerminatedAccount = _a.onTerminatedAccount,
    appleRedirectUrl = _a.appleRedirectUrl,
    triggeredFrom = _a.triggeredFrom,
    preventReCaptcha = _a.preventReCaptcha,
    isAuthCombined = _a.isAuthCombined,
    hideSocialActions = _a.hideSocialActions,
    _c = _a.hideOneTap,
    hideOneTap = _c === void 0 ? false : _c;
  var styles = useStyles$7();
  var _d = useAuthModalData(AuthModalDataForms.optionsForm),
    optionFormTitle = _d.title,
    optionFormDescription = _d.description,
    authOptions = _d.authOptions,
    buttonsOptions = _d.buttonsOptions;
  var _e = useRegistrationFormContext(),
    flow = _e.flow,
    email = _e.email,
    username = _e.username,
    password = _e.password,
    currentPage = _e.currentPage,
    setGeoZone = _e.setGeoZone,
    checkedStates = _e.checkedStates,
    action = _e.action,
    setStatus = _e.setStatus,
    setCurrentPage = _e.setCurrentPage;
  var _f = useAuthModalData(AuthModalDataForms.createPasswordForm),
    showUsernameFormOnSignIn = _f.showUsernameFormOnSignIn,
    showUsernameFormOnSignUp = _f.showUsernameFormOnSignUp;
  var Component = useCurrentPageComponent(currentPage);
  useGeoZone(function (geoZone) {
    return setGeoZone(geoZone);
  });
  useIsIncognito();
  var _g = useAuth({
      flow: flow,
      authSuccessHandler: authSuccessHandler,
      onTerminatedAccount: onTerminatedAccount,
      triggeredFrom: triggeredFrom,
      preventReCaptcha: preventReCaptcha,
      isAuthCombined: isAuthCombined,
      showUsernameFormOnSignIn: showUsernameFormOnSignIn,
      showUsernameFormOnSignUp: showUsernameFormOnSignUp
    }),
    onSubmit = _g.onSubmit,
    terminatedAccount = _g.terminatedAccount,
    handleTerminatedAccount = _g.handleTerminatedAccount,
    serverStatus = _g.serverStatus,
    handleAppleService = _g.handleAppleService,
    handleGoogleService = _g.handleGoogleService,
    handleFacebookService = _g.handleFacebookService,
    handleGeneralSocialServices = _g.handleGeneralSocialServices,
    onEmailCodeSend = _g.onEmailCodeSend,
    finalizeAuthWithStagedUser = _g.finalizeAuthWithStagedUser;
  var handleFormSubmit = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (!password && [ComponentsOptions.InsertPasswordForm, ComponentsOptions.CreatePasswordForm].includes(currentPage)) {
      setStatus({
        type: StatusOptions.Error
      });
    }
    if ((email || username) && password) {
      onSubmit({
        email: email,
        action: action,
        password: password,
        username: username,
        checkedStates: checkedStates
      });
    }
  }, [password, email, username, currentPage, setStatus, onSubmit, action, checkedStates]);
  useRegistrationAnalytics(currentPage, flow, isAuthCombined, triggeredFrom);
  useEffect(function () {
    setStatus(serverStatus);
  }, [serverStatus, setStatus]);
  useEffect(function () {
    if (terminatedAccount) {
      setCurrentPage(ComponentsOptions.AccountTermination);
    }
  }, [setCurrentPage, terminatedAccount]);
  var finalizeAuthWithStagedUserRef = useRef(finalizeAuthWithStagedUser);
  useEffect(function () {
    finalizeAuthWithStagedUserRef.current = finalizeAuthWithStagedUser;
  }, [finalizeAuthWithStagedUser]);
  useEffect(function () {
    return function () {
      finalizeAuthWithStagedUserRef.current();
    };
  }, []);
  return jsx("form", _assign({
    onSubmit: handleFormSubmit,
    className: classNames(styles.root, (_b = {}, _b[styles.scrollable] = currentPage === ComponentsOptions.OptionsForm, _b)),
    "data-testid": "authForm-root",
    "data-pulse-section-group": "registration_popup",
    "data-pulse-section": "auth-form",
    id: "auth-form",
    noValidate: true
  }, {
    children: jsx(Suspense, _assign({
      fallback: null
    }, {
      children: jsx(Component, {
        title: title || optionFormTitle,
        description: description || optionFormDescription,
        hideOneTap: hideOneTap,
        authOptions: authOptions,
        buttonsOptions: buttonsOptions,
        appleRedirectUrl: appleRedirectUrl,
        hideSocialActions: hideSocialActions,
        handleAppleClick: handleAppleService,
        handleGoogleClick: handleGoogleService,
        handleFacebookClick: handleFacebookService,
        onEmailCodeSend: onEmailCodeSend,
        onSubmit: onSubmit,
        authSuccessHandler: authSuccessHandler,
        handleGeneralSocialServices: handleGeneralSocialServices,
        triggeredFrom: triggeredFrom,
        terminationText: {
          title: terminatedAccount === null || terminatedAccount === void 0 ? void 0 : terminatedAccount.title,
          subTitle: terminatedAccount === null || terminatedAccount === void 0 ? void 0 : terminatedAccount.description
        },
        tcLinkText: terminatedAccount === null || terminatedAccount === void 0 ? void 0 : terminatedAccount.tc_link_text,
        cgLinkText: terminatedAccount === null || terminatedAccount === void 0 ? void 0 : terminatedAccount.cg_link_text,
        closeHandler: handleTerminatedAccount,
        finalizeAuthWithStagedUser: finalizeAuthWithStagedUser
      })
    }))
  }));
}

function FormContainer(_a) {
  var children = _a.children,
    className = _a.className;
  var loading = useRemoteSettingsContext().loading;
  var theme = useTheme();
  var styles = useStyles$8({
    theme: theme
  });
  if (loading) {
    return jsx("div", {});
  }
  return jsx("div", _assign({
    className: classNames(styles.root, className),
    "data-testid": "auth-form-container"
  }, {
    children: children
  }));
}

function RegistrationContent(_a) {
  var title = _a.title,
    description = _a.description,
    triggeredFrom = _a.triggeredFrom,
    preventReCaptcha = _a.preventReCaptcha,
    authSuccessHandler = _a.authSuccessHandler,
    onTerminatedAccount = _a.onTerminatedAccount,
    appleRedirectUrl = _a.appleRedirectUrl,
    location = _a.location,
    hideSocialActions = _a.hideSocialActions,
    formContainerClassName = _a.formContainerClassName,
    isAuthCombined = _a.isAuthCombined,
    _b = _a.hideOneTap,
    hideOneTap = _b === void 0 ? false : _b,
    redirectAfterEmailConfirmation = _a.redirectAfterEmailConfirmation,
    onPageChange = _a.onPageChange;
  useEffect(function () {
    if (!preventReCaptcha) {
      loadScript(RECAPTCHA_SCRIPT_SRC, {
        async: 'true'
      })["catch"](function (e) {
        return errorLogger.trigger(e, BUGSNAG_STATUSES.ERROR);
      });
    }
  }, [preventReCaptcha]);
  useEffect(function () {
    if (redirectAfterEmailConfirmation) {
      setStorage('redirectAfterEmailConfirmation', redirectAfterEmailConfirmation, false);
    }
  }, [redirectAfterEmailConfirmation]);
  return jsx(RegistrationFormProvider, _assign({}, defaultState, {
    onPageChange: onPageChange
  }, {
    children: jsx(FormContainer, _assign({
      className: formContainerClassName
    }, {
      children: jsx(AuthForm, {
        title: title,
        description: description,
        authSuccessHandler: authSuccessHandler,
        onTerminatedAccount: onTerminatedAccount,
        appleRedirectUrl: appleRedirectUrl,
        triggeredFrom: triggeredFrom,
        preventReCaptcha: preventReCaptcha,
        hideSocialActions: hideSocialActions,
        location: location,
        isAuthCombined: isAuthCombined,
        hideOneTap: hideOneTap
      })
    }))
  }));
}

function withAuthModal(Component) {
  return function HOC(_a) {
    var _this = this;
    var _b, _c;
    var props = __rest(_a, []);
    var hideCloseIcon = props.hideCloseIcon,
      isOpen = props.isOpen,
      onModalStateChange = props.onModalStateChange,
      authSuccessHandler = props.authSuccessHandler,
      triggeredFrom = props.triggeredFrom,
      triggeredBy = props.triggeredBy;
    var _d = useState({
        group: '',
        section: ''
      }),
      sectionAndGroup = _d[0],
      setSectionAndGroup = _d[1];
    var _e = useAuthModalData(AuthModalDataForms.modalVisuals),
      modalImage = _e.modalImage,
      reversed = _e.reversed,
      loading = _e.loading;
    var _f = useAuthContext(),
      onStatusChange = _f.onStatusChange,
      status = _f.status,
      user = _f.user;
    var _g = useStyles$9({
        reversed: reversed
      }),
      root = _g.root,
      image = _g.image,
      closeButton = _g.closeButton,
      modalCloseWrapper = _g.modalCloseWrapper;
    var _h = useState(false),
      isModalOpen = _h[0],
      setModalOpen = _h[1];
    var handleModalStateChange = useCallback(function (open) {
      return __awaiter(_this, void 0, void 0, function () {
        var screen_1;
        return __generator(this, function (_a) {
          if (onModalStateChange) {
            if (!open) {
              screen_1 = getStorage(ANALYTICS_SCREEN_NAME_KEY, false);
              AnalyticsService.sendEvent(REGISTRATION_DONE, {
                provider: '',
                registration_type: 'standard',
                braze: true,
                action_button: triggeredFrom,
                screen_name: screen_1,
                action: 'skip',
                platform: ANALYTICS_PLATFORM_TYPE
              });
              if (screen_1 === AnalyticsSkipScreenOptions.ToGetStarted) {
                AnalyticsService.sendEvent('consent_response', {
                  consent_type: 'registration_consent',
                  checkbox: getStorage(ANALYTICS_CONSENTS_KEY, false) || '',
                  action: 'close'
                });
              }
              removeStorage(ANALYTICS_SCREEN_NAME_KEY, false);
              removeStorage(ANALYTICS_CONSENTS_KEY, false);
              if (status === authStatus.done && user) {
                authSuccessHandler === null || authSuccessHandler === void 0 ? void 0 : authSuccessHandler(user);
                onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(authStatus.resolved);
              }
            }
            onModalStateChange(open);
          }
          setModalOpen(open);
          return [2];
        });
      });
    }, [authSuccessHandler, onModalStateChange, onStatusChange, status, triggeredFrom, user]);
    var closeCallback = useCallback(function () {
      return !hideCloseIcon ? handleModalStateChange(false) : {};
    }, [handleModalStateChange, hideCloseIcon]);
    useEffect(function () {
      if (isOpen) {
        setModalOpen(isOpen);
      }
    }, [isOpen]);
    useEffect(function () {
      var _a = window.location,
        pathname = _a.pathname,
        search = _a.search;
      var pathNameArr = pathname === null || pathname === void 0 ? void 0 : pathname.split('/').filter(function (i) {
        return i;
      });
      setSectionAndGroup({
        group: pathNameArr[pathNameArr.length - 1] || 'home',
        section: search || pathNameArr[pathNameArr.length - 1] || 'home'
      });
    }, []);
    if (!isModalOpen || loading) return null;
    return jsxs(Fragment, {
      children: [sectionAndGroup.group && sectionAndGroup.section && jsx("div", {
        "data-pulse-component": "registration",
        "data-pulse-component-type": triggeredBy ? "".concat(triggeredBy, "_generated") : 'click_generated',
        "data-pulse-section-group": sectionAndGroup.group,
        "data-pulse-section": sectionAndGroup.section
      }), jsx(Overlay, _assign({
        closeCallback: closeCallback,
        verticalAlign: VerticalAlign === null || VerticalAlign === void 0 ? void 0 : VerticalAlign.Middle,
        horizontalAlign: HorizontalAlign === null || HorizontalAlign === void 0 ? void 0 : HorizontalAlign.Center,
        zIndex: 100,
        "data-testid": "registration-overlay"
      }, {
        children: jsxs("div", _assign({
          className: root,
          "data-testid": "registration-modal-container"
        }, {
          children: [!hideCloseIcon && jsx("div", _assign({
            className: modalCloseWrapper,
            "data-pulse-name": "modal-close",
            "data-pulse-clickable": true
          }, {
            children: jsx(IconCrossCircleFilled, {
              width: 28,
              height: 28,
              className: closeButton,
              onClick: function onClick() {
                return handleModalStateChange(false);
              },
              "data-testid": "modal-close-icon"
            })
          })), jsx("div", _assign({
            className: image
          }, {
            children: jsx("img", {
              src: (_b = modalImage === null || modalImage === void 0 ? void 0 : modalImage.url) !== null && _b !== void 0 ? _b : imageData.smallUrl,
              alt: (_c = modalImage === null || modalImage === void 0 ? void 0 : modalImage.alt) !== null && _c !== void 0 ? _c : imageData.alt
            })
          })), jsx(Component, _assign({}, props))]
        }))
      }))]
    });
  };
}

var RegistrationModal = withAuthModal(RegistrationContent);
function RegistrationModalWithSettings(_a) {
  var props = __rest(_a, []);
  return jsx(RemoteSettingsProvider, {
    children: jsx(RegistrationModal, _assign({}, props))
  });
}

export { AuthButtons$1 as A, Footer as F, RegistrationModalWithSettings as R, RegistrationContent as a };
//# sourceMappingURL=RegistrationModal-652e90c4.js.map
